import { useQuery } from '@tanstack/react-query';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const DeliverableService = sdk.getService('DeliverableService');

export const useStudentDeliverablesStats = () => {
  const {
    profile,
    roleCheck: { isStudent }
  } = useProfile();

  const userId = profile?._id;

  const { data, isLoading, error } = useQuery({
    queryKey: ['student-deliverables-stats', userId],
    queryFn: () => DeliverableService.getStudentDeliverablesStats(),
    enabled: !!userId && isStudent
  });

  const totalDeliverables = data?.totalDeliverables ?? 0;
  const totalDeliverablesCompleted = data?.totalDeliverablesCompleted ?? 0;

  return {
    totalDeliverables,
    totalDeliverablesCompleted,
    isLoading,
    error
  };
};
